import { grey } from "@mui/material/colors";
import { generateTheme } from "@talentpair/quantic";
import { TalentpairTheme } from "@talentpair/quantic/theme/types";

export default function themeFromPrimary(color?: string): TalentpairTheme {
  return generateTheme(color ? { main: color } : grey);
}
